import {debounce} from "lodash";

/**
 * Initializes events related with sizing
 *
 */
function initCssSizing() {
    // Initialize top space padding
    updateTopSpacePadding();

    // Add resize event handler
    const debouncedHandler = debounce(updateTopSpacePadding, 256);

    // noinspection JSCheckFunctionSignatures
    window.addEventListener('resize', debouncedHandler);

    /**
     * Methods
     */

    /**
     * Calculates the top space padding, that is, navbar, headers, breadcrumbs...
     *
     * @return {number}
     */
    function getTopSpacePadding() {
        // Get header height
        const mainHeader = document.querySelector('.main-header');
        const navBarHeight = mainHeader ? mainHeader.getBoundingClientRect().height : 0;

        // Get content header (breadcrumbs, title, padding)
        const contentHeader = document.querySelector('.content-header');
        const contentHeaderHeight = contentHeader ? contentHeader.getBoundingClientRect().height : 0;

        // Calculate final padding
        return navBarHeight + contentHeaderHeight;
    }

    function updateTopSpacePadding() {
        const topPadding = getTopSpacePadding();
        const documentRoot = document.documentElement;

        documentRoot.style.setProperty('--sizing-top-space-padding', `${topPadding}px`);
    }
}

export {initCssSizing}
